// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"3f4a3a98","769":"d3a3555a"}[chunkId] + ".chunk.js";
};